export const PROJECTED_INVESTMENT_YEARS_COUNT = 40
